<template>
    <span
        class="flex items-center gap-2 font-medium leading-5"
        :class="variantClasses"
        :style="variantStyle"
        role="status"
        :aria-label="text"
    >
        <Icon icon="flame" class="w-5 h-5" />
        <span>{{ text }}</span>
    </span>
</template>
<script>
import Icon from '@/components/ui/icon/icon.vue';
export default {
    name: 'SpecialTag',
    components: {
        Icon,
    },
    props: {
        text: { type: String, default: 'Special welcome offer' },
        variant: {
            type: String,
            default: 'primary',
            validator: (v) => ['primary', 'secondary-soft', 'secondary-dark', 'secondary-soft-tab'].includes(v),
        },
    },
    computed: {
        variantClasses() {
            const map = {
                primary: 'rounded-full bg-[var(--primary-500,#f25c2b)] text-white px-2.5 py-1.5 text-sm',
                'secondary-soft': 'rounded-full bg-[var(--primary-50,#fff1eb)] text-orange ring-1 ring-[var(--primary-200,#fecab5)] px-2.5 py-1.5 text-sm',
                'secondary-dark': 'rounded-full bg-[var(--ink-900,#0f172a)] text-white px-2.5 py-1.5 text-sm',
                'secondary-soft-tab': 'items-start gap-2 pt-2 pr-6 pb-4 pl-4 bg-[var(--Special-Case-Orange-Bg-Light,#FEF0E7)] text-orange border border-[var(--10x-Orange-200,#FED1C7)] shadow',
            };
            return map[this.variant] || map.primary;
        },
        variantStyle() {
            if (this.variant === 'secondary-soft-tab') {
                return {
                    borderRadius: 'var(--radius-md, 8px) var(--radius-md, 8px) 0 0',
                };
            }
            return null;
        },
    },
};
</script>
